













import { createComponent } from "@vue/composition-api";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";
import router from "@/router";
import { Resource } from "@megarax/client/src";
import { RevisionActions } from "@megarax/client/src/revision";
import { ResourceAppModule } from "../../shared/app";
import { getModulePath } from "../../apps/getPath";

interface Props {
  items: RevisionItem[];
  module: ResourceAppModule;
}

export default createComponent<Props>({
  components: {},
  props: {
    items: { required: false, type: Array },
    module: { required: true },
  },
  setup(props, ctx) {
    function onRowClicked(draft: any) {
      router.push(getModulePath(props.module, draft.id));
    }

    return { onRowClicked };
  },
});
